import { render, staticRenderFns } from "./_AppNavigatorSection.vue?vue&type=template&id=1a570674&"
import script from "./_AppNavigatorSection.vue?vue&type=script&lang=js&"
export * from "./_AppNavigatorSection.vue?vue&type=script&lang=js&"
import style0 from "./_AppNavigatorSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports